// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"fdbVh","Breadcrumbs_gutter_horizontalMobile":"JXFx6"};